import React, { FC } from 'react';

export const Loading: FC = () => {
    return <div className="spinner m-auto" role="status" aria-hidden="true" />;
};
